<template>
  <figure
    v-if="isQuoteReference && quoteText"
    class="ao__quote-block"
  >
    <DefaultIconsQuote class="ao__quote-block-icon" />
    <blockquote v-html="quoteText" />
    <figcaption v-if="quoteAuthor">{{ quoteAuthor }}</figcaption>
  </figure>
  <div
    v-else-if="!isQuoteReference && !props.payload?.content?.length && !props.payload?.attributes?.referenceList?.length && !hiddenContents.includes(props.payload?.contentHTML)"
    :class="`ao__${props.type}`"
    v-html="props.payload?.rendered"
  />
  <div
    v-else-if="props.payload?.content?.length > 0"
    :class="`ao__${props.type}`"
  >
    <DefaultArticlesArtObject
      v-for="(content, index) in props.payload?.content"
      :type="content?.type"
      :payload="content"
      :parent-ident="`${props.parentIdent}|${props.type}-${index}`"
    />
  </div>
  <div
    v-else-if="props.payload?.attributes?.referenceList?.length > 0"
    :class="`ao__${props.type}`"
  >
    <DefaultArticlesArtObject
      v-for="(content, index) in props.payload?.attributes?.referenceList"
      :type="content?.type"
      :payload="content"
      :parent-ident="`${props.parentIdent}|${props.type}-${index}`"
    />
  </div>
  <div v-else />
</template>


<script setup lang="ts">
const props = defineProps({
  type: { type: String, required: true },
  payload: { type: Object, required: false },
  parentIdent: { type: String, required: false },
})

const hiddenContents = ['_tip_']

const isQuoteReference = computed(() => {
  return props.payload?.attributes?.reference?.type === 'quote'
})

const quoteText = computed(() => {
  return props.payload?.attributes?.reference?.primaryText || null
})

const quoteAuthor = computed(() => {
  const textField = props.payload?.attributes?.reference?.text
  if (!textField) return null
  try {
    const parsed = JSON.parse(textField)
    return parsed?.children?.[0]?.text || null
  } catch {
    return null
  }
})
</script>

<style lang="postcss" scoped>
</style>
